/* Te Abastece: ficha de producto.
   1) "Agrega a tu pedido": recomendaciones de Shopify con botón para sumar al carrito.
   2) Widget de packs (MaxBundle): precios en formato chileno, colores de la marca,
      título propio y sello "Mayor ahorro" solo en el pack con mayor descuento. */
(function () {
  if (window.__taPdp) return;
  window.__taPdp = true;

  var fmt = function (n) { return '$' + Math.round(n).toLocaleString('es-CL'); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- 1. Upsell ---------- */
  function initUpsell(box) {
    var id = box.dataset.productId, limit = +box.dataset.limit || 3;
    var get = function (intent) {
      return fetch(root + 'recommendations/products.json?product_id=' + id + '&limit=' + (limit + 3) + '&intent=' + intent)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d.products || []).filter(function (p) { return p.available && String(p.id) !== id; }); })
        .catch(function () { return []; });
    };
    get('complementary').then(function (list) {
      return list.length >= 2 ? list : get('related').then(function (rel) {
        var seen = {}; return list.concat(rel).filter(function (p) { return seen[p.id] ? false : (seen[p.id] = true); });
      });
    }).then(function (list) {
      list = list.slice(0, limit);
      if (!list.length) return;
      var ul = box.querySelector('.ta-upsell__list');
      ul.innerHTML = list.map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        var img = p.featured_image || '';
        img = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
        return '<li class="ta-upsell__item">' +
          '<a class="ta-upsell__img" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
          '<a class="ta-upsell__name" href="' + p.url + '">' + esc(p.title) + '</a>' +
          '<span class="ta-upsell__price">' + fmt(v.price / 100) + '</span>' +
          '<button type="button" class="ta-upsell__add" data-variant="' + v.id + '" aria-label="Agregar ' + esc(p.title) + ' al carrito">Agregar</button>' +
          '</li>';
      }).join('');
      box.hidden = false;
    });

    box.addEventListener('click', function (e) {
      var b = e.target.closest('.ta-upsell__add');
      if (!b || b.disabled) return;
      b.disabled = true; b.textContent = 'Agregando…';
      fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +b.dataset.variant, quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw r; return fetch(root + 'cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          b.textContent = 'Agregado ✓'; b.classList.add('is-added');
          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = { resource: cart, sourceId: 'ta-upsell', data: { source: 'ta-upsell', itemCount: cart.item_count } };
          document.dispatchEvent(ev);
        })
        .catch(function () { b.disabled = false; b.textContent = 'Reintentar'; });
    });
  }

  /* ---------- 2. Widget de packs ---------- */
  var COLORS = [
    [/rgb\(118,\s*32,\s*235\)/g, 'rgb(102, 30, 114)'],   // morado de la app -> morado de la marca
    [/#7620eb/gi, '#661e72'],
    [/rgb\(244,\s*237,\s*255\)/g, 'rgb(240, 229, 244)']   // fondo seleccionado -> morado suave
  ];
  var MONEY = /CLP\s*\$\s*([\d.,]+)/g, HAS_MONEY = /CLP\s*\$/;
  function money(s) { return s.replace(MONEY, function (_, n) { return fmt(parseFloat(n.replace(/,/g, ''))); }); }

  function polish(w) {
    // textos con precio
    var walker = document.createTreeWalker(w, NodeFilter.SHOW_TEXT), n, fix = [];
    while ((n = walker.nextNode())) if (HAS_MONEY.test(n.nodeValue)) fix.push(n);
    fix.forEach(function (t) { t.nodeValue = money(t.nodeValue).replace(/Ahorras\s*-\s*/, 'ahorras '); });
    // botón del pack: que se distinga del botón por unidad
    w.querySelectorAll('.upsell-add-cart-btn-text').forEach(function (b) {
      var v = b.textContent.replace(/^Agregar al carrito\s*\|\s*/, 'Agregar pack · ');
      if (v !== b.textContent) b.textContent = v;
    });
    // colores
    w.querySelectorAll('[style]').forEach(function (el) {
      var s = el.getAttribute('style'), o = s;
      COLORS.forEach(function (c) { s = s.replace(c[0], c[1]); });
      if (s !== o) el.setAttribute('style', s);
    });
    // título propio una sola vez
    var list = w.querySelector('.max-bundles__discounts');
    if (list && !w.querySelector('.ta-packs-head')) {
      var h = document.createElement('div');
      h.className = 'ta-packs-head';
      h.innerHTML = '<strong>Precio por volumen</strong><span>Elige un pack y paga menos por unidad</span>';
      list.parentNode.insertBefore(h, list);
    }
    // sello solo en el pack con mayor descuento
    var tiers = [].slice.call(w.querySelectorAll('.max-bundles__discount'));
    var pct = tiers.map(function (t) { var m = (t.textContent || '').match(/(\d+)\s*%/); return m ? +m[1] : 0; });
    var max = Math.max.apply(null, pct.concat([0]));
    tiers.forEach(function (t, i) {
      var badge = t.querySelector('.popular_badge span');
      if (!badge) return;
      if (pct[i] === max && max > 0) { if (badge.textContent !== 'Mayor ahorro') badge.textContent = 'Mayor ahorro'; }
      else t.querySelector('.popular_badge').style.display = 'none';
    });
  }

  function watchBundles() {
    var busy = false;
    var run = function () {
      if (busy) return; busy = true;
      document.querySelectorAll('.cxbundle-funnel').forEach(polish);
      busy = false;
    };
    run();
    var timer;
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(run, 40); })
      .observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] });
  }

  var start = function () {
    document.querySelectorAll('[data-ta-upsell]').forEach(initUpsell);
    if (document.querySelector('.cxbundle-funnel, [id*="maxbundle"]')) watchBundles();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
